/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Admin_Billing_DescriptionInputs */

const es_walkthrough_admin_billing_description = /** @type {(inputs: Walkthrough_Admin_Billing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisá las últimas facturas, el historial de pagos y recargas. Podés cambiar la moneda y ver el detalle de cada factura generada.`)
};

const en_walkthrough_admin_billing_description = /** @type {(inputs: Walkthrough_Admin_Billing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review the latest invoices, payment history, and refills. You can switch currencies and view the details of each generated invoice.`)
};

/**
* | output |
* | --- |
* | "Review the latest invoices, payment history, and refills. You can switch currencies and view the details of each generated invoice." |
*
* @param {Walkthrough_Admin_Billing_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_admin_billing_description = /** @type {((inputs?: Walkthrough_Admin_Billing_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Admin_Billing_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_admin_billing_description(inputs)
	return en_walkthrough_admin_billing_description(inputs)
});
export { walkthrough_admin_billing_description as "walkthrough.admin_billing_description" }